import { AxiosResponse } from "axios";
import { useQuery } from "react-query";
import api, { leaderboard_url } from "../../misc/api";
import {
  LeaderboardItem,
  LeaderboardItemSchema,
} from "../../types/leaderboard";
import baseOptions from "./baseOptions";

async function fetchLeaderboard() {
  try {
    const { data }: AxiosResponse<{ data: LeaderboardItem[] }> =
      await api.get(leaderboard_url);
    const safeParsedData = LeaderboardItemSchema.array()
      .parse(data.data)
      .sort((a, b) => Number(a.rankOrder) - Number(b.rankOrder));
    return safeParsedData;
  } catch (e) {
    throw new Error(e instanceof Error ? e.message : String(e));
  }
}

function useLeaderboard() {
  return useQuery("leaderboard", () => fetchLeaderboard(), {
    ...baseOptions,
    retry: 3,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}

export default useLeaderboard;
